import React from "react";

export default function Cardlist(props) {
    const { list, setList } = props;

    // 点赞/取消点赞的处理函数
    const handleGood = (ele) => {
        const newList = list.map(item => {
            if (item.id === ele.id) {
                return { ...item, isGood: !item.isGood };
            }
            return item;
        });
        setList(newList);
    };

    return (
        <>
            {list.map(ele => (
                <div className="cardbox" key={ele.id}>
                    <img src={ele.imgUrl} alt="" />
                    <div className="cardwrapper">
                        <p className="good">有{ele.goodNum}人觉得很赞</p>
                        <span
                            className={"iconfont icon-tuijian " + (ele.isGood ? "isGood" : "")}
                            onClick={() => handleGood(ele)}
                        ></span>
                    </div>
                </div>
            ))}
        </>
    );
}